import React, { ReactNode } from "react";

import { Checkbox, Typography, TypographyVariant } from "@material-ui/core";

import { useStyles } from "./useStyles";

import { RollupsItemType } from "../../RollupsList/helpers";

interface IProps {
  label: string;
  type: RollupsItemType;
  icon: ReactNode;
  level: 0 | 1 | 2;
  selected: boolean;
  variant?: TypographyVariant;
  spacing?: number;
  disabled?: boolean;
  withCheckbox?: boolean;
  height?: number;
}

const RollupsSelectOption: React.FC<IProps> = props => {
  const {
    label,
    type,
    icon,
    level,
    selected,
    variant = "caption",
    spacing = 0,
    disabled,
    withCheckbox,
    height
  } = props;

  const classes = useStyles({
    level,
    type,
    label,
    spacing,
    disabled,
    height,
    withCheckbox
  });

  return (
    <div className={classes.container}>
      {withCheckbox && (
        <Checkbox size="small" color="primary" checked={selected} />
      )}

      {label !== "Ungrouped Projects" && (
        <span className={classes.icon}>{icon}</span>
      )}

      <Typography
        variant={variant}
        className={classes.label}
        title={label}
        noWrap
      >
        {selected && !withCheckbox && (
          <span className={classes.currentLabel}>[Current]</span>
        )}
        {label}
      </Typography>
    </div>
  );
};

export default React.memo(RollupsSelectOption);
